import gql from 'graphql-tag';

const UPDATE_SSL_DEVICE = gql`
  mutation Mutation($deviceSerialNo: String!, $ssl: Int!) {
    updateSSL(deviceSerialNo: $deviceSerialNo, ssl: $ssl) {
      code
    }
  }
`;

export default UPDATE_SSL_DEVICE;
